var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchipelagosLabsTransparentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:1.49;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:1.49;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:1.49;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000094610503993333859700000011836067493048451987_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.6,
    y1: 47.4,
    x2: 38.5,
    y2: 47.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.8,
    y1: 18.1,
    x2: 10.8,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.5,
    y1: 54.7,
    x2: 43,
    y2: 54.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,40.9V7.2c0-0.5,0.4-1,1-1h35.8c0.5,0,1,0.4,1,1v13.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,31.1c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c0,0,0,0,0,0 C39.4,28.6,40.5,29.7,40.5,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43,15c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5C41.8,12.4,42.9,13.6,43,15 C43,14.9,43,14.9,43,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.6,29.5c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c0,0,0,0,0,0 C19.4,27,20.5,28.1,20.6,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28,20c0,1.4-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5l0,0C26.8,17.5,28,18.6,28,20z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 19.7,
    y1: 27.6,
    x2: 23.8,
    y2: 21.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 27.6,
    y1: 21.3,
    x2: 31.4,
    y2: 24.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.9,48.4l-7.3-8.9c3.8-4.7,3-11.6-1.7-15.3s-11.6-3-15.3,1.7s-3,11.6,1.7,15.3c2.8,2.2,6.4,2.9,9.8,2 l2.3,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.2,61.4c-0.5,1.8-2.8,2.2-3.9,1.8l-0.7-3c-0.8,0.4-1.7,0.5-2.5,0.3l-0.5-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.7,63.8h-8.5c-1.7,0.1-3.3-0.5-4.5-1.7l-5.3-5.6l-6.9-5.9c-1-0.9-1-2.5-0.1-3.5c0,0,0.1-0.1,0.1-0.1 c1.2-1.4,2.4-1.4,3.4-0.7l6.9,5.8v-3.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "49,37.4 59.3,42.4 66.8,52.4 69.7,53.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,63.7c0.9-1.2,2.8-3.7,3.2-4.3c0.4-0.6,1-2.3,2.3-6.1c0.8-2.3,3.5-8.9,3.5-8.9c0.3-1.4-0.6-2.7-1.9-3 c-1.3-0.5-2.8,0-3.4,1.2l-4.7,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,35.1L1.6,46.6c-0.7,1-1,2.2-0.8,3.4l0.5,11.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 39.5,
    y1: 21.8,
    x2: 40.1,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 38.4,
    y1: 28.6,
    x2: 39.1,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 33.5,
    y1: 26.9,
    x2: 36.2,
    y2: 29.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchipelagosLabsTransparentIcon);
export default __webpack_public_path__ + "static/media/Archipelagos_Labs-TransparentIcon.b3e572ab6de7cdd0dd6850998fc1272e.svg";
export { ForwardRef as ReactComponent };